export default __webpack_public_path__ + "static/media/StatusEndedNoErrors.50eda50a.png";